import React from 'react';

import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Tooltip from '@amzn/meridian/tooltip';

import EmDash from '../emdash';

const PlacementInfo = ({ label, value, tooltip }: { label: string; value?: string | number; tooltip?: string }) => {
  const content = <Text>{value ?? <EmDash />}</Text>;
  return (
    <Column spacing="100">
      <Text color="secondary">{label}</Text>
      {tooltip ? (
        <Tooltip title={tooltip} position="bottom">
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </Column>
  );
};

export default PlacementInfo;
